var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "omegaup-overlay-popup",
    {
      on: {
        dismiss: function ($event) {
          return _vm.$emit("dismiss")
        },
      },
    },
    [
      _c(
        "form",
        {
          staticClass: "modal-form h-100",
          attrs: { "data-new-clarification": "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "form-group row mt-5" }, [
            _c(
              "label",
              { staticClass: "col-md-6 col-form-label modal-form__label" },
              [
                _vm._v(" " + _vm._s(_vm.T.wordsProblem) + " "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentProblemAlias,
                        expression: "currentProblemAlias",
                      },
                    ],
                    staticClass: "form-control modal-form__control",
                    attrs: {
                      required: "required",
                      "data-new-clarification-problem": "",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.currentProblemAlias = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.problems, function (problem) {
                    return _c(
                      "option",
                      {
                        key: problem.alias,
                        domProps: { value: problem.alias },
                      },
                      [_vm._v(" " + _vm._s(problem.text) + " ")]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm.users.length != 0
              ? _c(
                  "label",
                  { staticClass: "col-md-6 col-form-label modal-form__label" },
                  [
                    _vm._v(" " + _vm._s(_vm.T.wordsMessageTo) + " "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentUsername,
                            expression: "currentUsername",
                          },
                        ],
                        staticClass: "form-control modal-form__control",
                        attrs: {
                          required: _vm.users,
                          "data-new-clarification-user": "",
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.currentUsername = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.filteredUsers, function (user) {
                        return _c(
                          "option",
                          {
                            key: user.username,
                            domProps: { value: user.username },
                          },
                          [_vm._v(" " + _vm._s(user.name) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-md-12 col-form-label modal-form__label" },
              [
                _vm._v(" " + _vm._s(_vm.T.arenaClarificationCreate) + " "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message",
                    },
                  ],
                  staticClass: "form-control modal-form__control",
                  attrs: {
                    maxlength: "200",
                    required: "required",
                    placeholder: _vm.T.arenaClarificationMaxLength,
                    "data-new-clarification-message": "",
                  },
                  domProps: { value: _vm.message },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.message = $event.target.value
                    },
                  },
                }),
              ]
            ),
          ]),
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-sm-12 modal-form__actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "submit",
                    disabled: !_vm.canSubmitClarification,
                  },
                },
                [_vm._v(" " + _vm._s(_vm.T.wordsSend) + " ")]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }